import './Gauge.scss'

import React, {Component} from 'react'

const DIAL_CONFIG = {
  radius: 40,
  startAngle: 155,
  endAngle: 25,
}

class Gauge extends Component {

  componentDidMount = () => {
    this.renderGauge(this.props)
  }

  shouldComponentUpdate = nextProps => {
    if (this.props.value !== nextProps.value) {
      this.renderGauge(nextProps)
    }
    return false
  }

  svg = (name, attrs, children) => {
    const elem = document.createElementNS("http://www.w3.org/2000/svg", name)
    Object.keys(attrs).forEach(attrName => {
      elem.setAttribute(attrName, attrs[attrName])
    })

    _.forEach(children, child => {
      elem.appendChild(child)
    })
    return elem
  }

  easing = pos => {
    // https://github.com/danro/easing-js/blob/master/easing.js
    if ((pos/=0.5) < 1) return 0.5*Math.pow(pos,3)
    return 0.5 * (Math.pow((pos-2),3) + 2)
  }

  doAnimation = (oldVal, val, step) => {
    const iterations = 60
    const change = val - oldVal
    let iteration = 1

    const animate = () => {
      const progress = iteration / iterations
      const value = change * this.easing(progress) + oldVal

      step(value, iteration)
      iteration += 1

      if (progress < 1) {
        requestAnimationFrame(animate)
      }
    }
    requestAnimationFrame(animate)
  }

  getAngle = (percentage, gaugeSpanAngle) => {
    return percentage * gaugeSpanAngle / 100
  }

  getCartesian = (cx, cy, radius, angle) => {
    const rad = angle * Math.PI / 180
    return {
      x: Math.round((cx + radius * Math.cos(rad)) * 1000) / 1000,
      y: Math.round((cy + radius * Math.sin(rad)) * 1000) / 1000
    }
  }

  getDialCoords = (radius, startAngle, endAngle) => {
    const cx = 50
    const cy = 50
    return {
      end: this.getCartesian(cx, cy, radius, endAngle),
      start: this.getCartesian(cx, cy, radius, startAngle)
    }
  }

  dialPathString = (radius, startAngle, endAngle, largeArc) => {
    const coords = this.getDialCoords(radius, startAngle, endAngle)
    const start = coords.start
    const end = coords.end
    const largeArcFlag = typeof(largeArc) === "undefined" ? 1 : largeArc

    return [
      "M", start.x, start.y,
      "A", radius, radius, 0, largeArcFlag, 1, end.x, end.y
    ].join(" ")
  }

  updateGauge = (val) => {
    const { startAngle, endAngle, radius } = DIAL_CONFIG

    const angle = this.getAngle(val, 360 - Math.abs(startAngle - endAngle))
    const flag = angle <= 180 ? 0 : 1
    this.gauge.gaugePath.setAttribute("d", this.dialPathString(radius, startAngle, angle + startAngle, flag))
  }

  createGauge = () => {
    const { radius, startAngle, endAngle } = DIAL_CONFIG
    const { leftLabel='Fewer', rightLabel='More', titleLabel='' } = this.props

    const angle = this.getAngle(100, 360 - Math.abs(startAngle - endAngle))
    const flag = angle <= 180 ? 0 : 1
    const gaugeBackgroundPath = this.svg("path", {
      "class": "Gauge_dial",
      fill: "none",
      stroke: "#eee",
      "stroke-width": 3,
      "stroke-linecap": "round",
      d: this.dialPathString(radius, startAngle, endAngle, flag)
    })

    const gaugeValuePath = this.svg("path", {
      "class": "Gauage__dial_path",
      fill: "none",
      stroke: "#00C981",
      "stroke-width": 9,
      "stroke-linecap": "round",
      d: this.dialPathString(radius, startAngle, startAngle)
    })

    const gaugeMoon = this.svg("path", {
      "class": "Gauge__moon",
      fill: "#eee",
      "transform": "rotate(180) translate(-64, -84) scale(.28)",
      d: "M 0 50 a 1 1 0 0 0 100 0"
    })

    const leftText = this.svg("text", {
      x: 15,
      y: 82,
      fill: "#4A4A4A",
      "class": "Gauge__text",
      "font-size": "11",
      "font-family": "Circular",
      "font-weight": "normal",
      "text-anchor": "middle",
      "alignment-baseline": "middle",
      "dominant-baseline": "central"
    }, leftLabel ? [document.createTextNode(leftLabel)] : [])

    const rightText = this.svg("text", {
      x: 84,
      y: 82,
      fill: "#4A4A4A",
      "class": "Gauge__text",
      "font-size": "11",
      "font-family": "Circular",
      "font-weight": "normal",
      "text-anchor": "middle",
      "alignment-baseline": "middle",
      "dominant-baseline": "central"
    }, rightLabel ? [document.createTextNode(rightLabel)] : [])

    const titleText = this.svg("text", {
      x: 50,
      y: 82,
      fill: "#4A4A4A",
      "class": "Gauge__text",
      "font-size": "9",
      "font-family": "Circular",
      "font-weight": "normal",
      "text-anchor": "middle",
      "alignment-baseline": "middle",
      "dominant-baseline": "central"
    }, titleLabel ? [document.createTextNode(titleLabel)] : [])

    const gaugeElement = this.svg("svg", {"viewBox": "0 0 100 100", "class": "Gauge"},
      [
        gaugeBackgroundPath,
        gaugeValuePath,
        gaugeMoon,
        leftText,
        rightText,
        titleText,
      ]
    )
    this.gaugeRef.appendChild(gaugeElement)

    const needle = document.createElement('div')
    needle.setAttribute('class', 'Gauge__needle')
    this.gaugeRef.appendChild(needle)

    return {
      setValue: val => {
        this.doAnimation(this.props.value, val, this.updateGauge)
        const rotate = Math.round((val / 100 * 180) - 90)
        this.gauge.needle.setAttribute("style", `transform:rotate(${rotate}deg)`)
      },
      gaugePath: gaugeValuePath,
      needle
    }
  }

  renderGauge = (props) => {
    if (!this.gauge) {
      this.gauge = this.createGauge()
    }
    this.gauge.setValue(props.value)
  }

  render() {
    return <div className="Gauge" ref={ref => this.gaugeRef = ref}/>
  }
}

export default Gauge